
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ExpenseList from "./pages/ExpenseList";
import CreateOrganization from "./pages/CreateOrganization";
import CreateOrganizationContacts from "./pages/CreateOrganizationContacts";
import Organizations from "./pages/Organizations";
import Dashboard from "./pages/Dashboard";
import Reports from "./pages/Reports";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import ExpenseReportsPage from "./pages/ExpenseReports";
import CreateExpenseReport from "./pages/CreateExpenseReport";
import ExpenseReportDetail from "./pages/ExpenseReportDetail";
import AddExpensePage from "./pages/AddExpensePage";
import { BottomNavigation } from "./components/BottomNavigation";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

const App = () => (
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <div className="relative min-h-screen bg-background">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/app">
              <Route index element={<Organizations />} />
              <Route path="organizations" element={<Organizations />} />
              <Route path=":organizationId">
                {/* Default route for organization ID should be dashboard */}
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="expenses" element={<ExpenseList />} />
                <Route path="add-expense" element={<AddExpensePage />} />
                <Route path="reports" element={<Reports />} />
                <Route path="expense-reports" element={<ExpenseReportsPage />} />
                <Route path="expense-reports/new" element={<CreateExpenseReport />} />
                <Route path="expense-reports/:reportId" element={<ExpenseReportDetail />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Route>
            {/* Add route to handle /organizations/:organizationId/expense-reports pattern */}
            <Route path="/organizations/:organizationId/expense-reports" element={<ExpenseReportsPage />} />
            <Route path="/create-organization">
              <Route index element={<CreateOrganization />} />
              <Route path="contacts" element={<CreateOrganizationContacts />} />
            </Route>
            {/* Catch-all redirect to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <BottomNavigation />
          <Toaster />
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  </BrowserRouter>
);

export default App;
